export const StyleLine = [
    {
        value: 'solid',
        label: 'Solid',
    },
    {
        value: 'dotted',
        label: 'Dotted',
    },
    {
        value: 'dashed',
        label: 'Dashed',
    },
];

export const TypeLine = [
    {
        value: 'straight',
        label: 'Straight',
    },
    {
        value: 'bezier',
        label: 'Bezier',
    },
    {
        value: 'taxi',
        label: 'Taxi',
    },
];

export const StyleShape = [
    {
        value: 'circle',
        label: 'Circle',
    },
    {
        value: 'rectangle',
        label: 'Rectangle',
    },
    {
        value: 'person',
        label: 'Person',
    },
    {
        value: 'ellipse',
        label: 'Ellipse'
    },
    {
        value: 'triangle',
        label: 'Triangle'
    },
    {
        value: 'round-triangle',
        label: 'Round-triangle'
    },
    {
        value: 'round-rectangle',
        label: 'Round-rectangle'
    },

    {
        value: 'bottom-round-rectangle',
        label: 'Bottom-round-rectangle'
    },
    {
        value: 'cut-rectangle',
        label: 'Cut-rectangle'
    },
    {
        value: 'barrel',
        label: 'Barrel'
    },
    {
        value: 'rhomboid',
        label: 'Rhomboid'
    },
    {
        value: 'right-rhomboid',
        label: 'Right-rhomboid'
    },
    {
        value: 'diamond',
        label: 'Diamond'
    },
    {
        value: 'round-diamond',
        label: 'Round-diamond'
    },
    {
        value: 'pentagon',
        label: 'Pentagon'
    },
    {
        value: 'round-pentagon',
        label: 'Round-pentagon'
    },
    {
        value: 'hexagon',
        label: 'Hexagon'
    },
    {
        value: 'round-hexagon',
        label: 'Round-hexagon'
    },
    {
        value: 'concave-hexagon',
        label: 'Concave-hexagon'
    },
    {
        value: 'heptagon',
        label: 'Heptagon'
    },
    {
        value: 'round-heptagon',
        label: 'Round-heptagon'
    },
    {
        value: 'octagon',
        label: 'Octagon'
    },
    {
        value: 'round-octagon',
        label: 'Round-octagon'
    },
    {
        value: 'star',
        label: 'Star'
    },
    {
        value: 'tag',
        label: 'Tag'
    },
    {
        value: 'round-tag',
        label: 'Round-tag'
    },
    {
        value: 'vee',
        label: 'Vee'
    },
];

